import { render, staticRenderFns } from "./DocsPageSection.vue?vue&type=template&id=d1a86c88&scoped=true&"
import script from "./DocsPageSection.vue?vue&type=script&lang=js&"
export * from "./DocsPageSection.vue?vue&type=script&lang=js&"
import style0 from "./DocsPageSection.vue?vue&type=style&index=0&id=d1a86c88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1a86c88",
  null
  
)

export default component.exports